import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class KbMyOwnPartNumbersService {
  constructor(private http: HttpClient,
    private occService: OccEndpointsService,) { }
  getApi() {
    return this.http.get(this.occService.buildUrl(`myparts/getmyPart`));
  }
  postApiForUploadFile(payLoad, codes) {
    return this.http.post(this.occService.buildUrl(`myparts/update-myPart/getCustomerPartCount?${codes}`), payLoad);
  }
  secondPostApiForUploadFile(payLoad, codes) {
    return this.http.post(this.occService.buildUrl(`myparts/update-myPart?${codes}`), payLoad);
  }
  postApiForDownloadFile(payLoad) {
    return this.http.post(this.occService.buildUrl(`myparts/mypart-download?${payLoad}`), payLoad);
  }
}
